import { useEffect, useMemo } from 'react';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';

import {
  selectCompetitionPinnedFilters,
  togglePinnedFiltersState,
} from '@store';
import { useHasFilters } from 'hooks/common';

const getFilterValue = (queryParam = '', data = []) =>
  data.find((option) => option.value === queryParam) || {};

export const useCompetitionVehiclesFilterConfig = ({ enums }) => {
  const router = useRouter();
  const pinnedFilters = useSelector(selectCompetitionPinnedFilters);
  const dispatch = useDispatch();

  const { brands } = enums;

  const brandFilterValue = getFilterValue(router.query?.brand, brands) || [];
  const models = brandFilterValue?.models || [];

  useEffect(() => {
    if (!router.query.brand && router.query.model) {
      delete router.query.model;
      router.push(router);
    }

    // When model on url do not match with the selected brand
    if (
      brandFilterValue &&
      router.query.model &&
      !brandFilterValue?.models?.find(
        (model) => model.value === router.query.model
      )
    ) {
      delete router.query.model;
      router.push(router);
    }
  }, [router.query]); // eslint-disable-line react-hooks/exhaustive-deps

  const filterCategories = useMemo(
    () => [
      {
        id: 'brand',
        label: 'Brands',
        icon: PanoramaFishEyeIcon,
        options: brands,
        multiSelect: false,
      },
      {
        id: 'model',
        label: 'Models',
        icon: PanoramaFishEyeIcon,
        options: models,
        multiSelect: false,
      },
    ],
    [brands, models]
  );
  const { hasFilters } = useHasFilters({ pinnedFilters });

  const currentFilters = useMemo(() => {
    const parseQueryValue = (value) => {
      if (!value) return [];
      if (typeof value === 'string') {
        return value.split(',').filter(Boolean);
      }
      return Array.isArray(value) ? value : [];
    };

    return {
      brand: parseQueryValue(router.query.brand),
      model: parseQueryValue(router.query.model),
    };
  }, [router.query]);

  const handlePinnedFilterSelect = (pinnedFilter) => {
    dispatch(togglePinnedFiltersState({ board: 'competition', pinnedFilter }));
  };

  return {
    filterCategories,
    currentFilters,
    pinnedFilters,
    supportPinnedFilters: true,
    hasFilters,
    handlePinnedFilterSelect,
  };
};
